/**
 * Composant d'onglets piloté par le sélecteur « I want to » (theme-dropdown, le composant des sélecteurs de pays et de
 * langue), avec support de l'éditeur de thème.
 */
if (!customElements.get('tabs-component')) {
  class TabsComponent extends HTMLElement {
    connectedCallback() {
      this.tabsDropdown = this.querySelector('.collection-tabs__dropdown');
      this.tabsContent = this.querySelector('.tabs-content');

      if (!this.tabsDropdown || !this.tabsContent) {
        return;
      }

      // Un besoin choisi dans la liste affiche son onglet ; la liste se ferme d'elle-même (theme-dropdown)
      this.tabsDropdown.querySelectorAll('a[data-value]').forEach((link) => {
        link.addEventListener('click', (event) => {
          event.preventDefault();
          this.selectTab(link.dataset.value);
          // Au clavier, le focus revient au bouton : la liste refermée masque le besoin choisi
          this.tabsDropdown.querySelector('.dropdown-button').focus();
        });
      });

      const defaultTabId = this.getDefaultTabId();

      if (defaultTabId) {
        this.selectTab(defaultTabId);
      }

      if (typeof Shopify !== 'undefined' && Shopify.designMode) {
        document.addEventListener('shopify:block:select', this.handleBlockSelect.bind(this));
      }
    }

    /**
     * Retourne les identifiants des onglets, dans l'ordre de la liste.
     *
     * @returns {string[]} Identifiants des panneaux (ex. tab-123)
     */
    getTabIds() {
      return Array.from(this.tabsDropdown.querySelectorAll('a[data-value]'), (link) => link.dataset.value);
    }

    /**
     * Détermine l'onglet affiché au chargement (fixe ou aléatoire).
     *
     * @returns {string|undefined} Identifiant du panneau à activer
     */
    getDefaultTabId() {
      const tabIds = this.getTabIds();

      if (tabIds.length === 0) {
        return undefined;
      }

      if (this.dataset.randomDefault === 'true') {
        return tabIds[Math.floor(Math.random() * tabIds.length)];
      }

      return this.dataset.defaultTab || tabIds[0];
    }

    /**
     * Affiche un onglet et le marque dans le sélecteur : besoin courant actif, libellé du bouton.
     *
     * @param {string} tabId - Identifiant du panneau (ex. tab-123)
     */
    selectTab(tabId) {
      const link = this.tabsDropdown.querySelector(`a[data-value="${tabId}"]`);

      // Un bloc d'une autre section sélectionné dans l'éditeur : rien à faire ici
      if (!link) {
        return;
      }

      this.tabsContent.querySelectorAll('.tab-content').forEach((content) => {
        const isActive = content.getAttribute('id') === tabId;

        content.classList.toggle('active', isActive);
        content.hidden = !isActive;
      });

      this.tabsDropdown.querySelectorAll('li').forEach((item) => {
        item.classList.toggle('is-active', item.contains(link));
      });

      // theme-dropdown affiche le libellé dans le premier span du bouton
      const buttonText = this.tabsDropdown.querySelector('.dropdown-button span');

      if (buttonText) {
        buttonText.textContent = link.textContent.trim();
      }
    }

    /**
     * Sélectionne l'onglet correspondant au bloc édité dans le theme editor.
     *
     * @param {CustomEvent} event - Événement shopify:block:select
     */
    handleBlockSelect(event) {
      this.selectTab(`tab-${event.detail.blockId}`);
    }
  }

  customElements.define('tabs-component', TabsComponent);
}
